import {Injectable} from '@angular/core';
import {PreloadingStrategy, Route} from '@angular/router';
import {Observable, of, timer} from 'rxjs';
import {map, tap} from 'rxjs/operators';
import {AppStore} from 'app/shared/store/app.store';

/**
 * Implémentation de PreloadingStrategy.
 * Les modules ayant "preload: true" dans leur données de route sont préchargés.
 */
@Injectable({
    providedIn: 'root'
})
export class CustomPreloadingStrategyService implements PreloadingStrategy {

    constructor(
        private appStore: AppStore,
    ) {
    }

    preload(route: Route, fn: () => Observable<any>): Observable<any> {
        const loadRoute = (delay) => {
            if (delay > 0) {
                return timer(delay * 1000).pipe(
                    map(() => fn())
                );
            } else {
                return fn();
            }
        };
        if (route.data && route.data['modulePreload']) {
            const delay = route.data['modulePreloadDelaySeconds'] ? route.data['modulePreloadDelaySeconds'] : 0;
            return loadRoute(delay).pipe(
                tap(() => {
                    if (route.data['moduleName'] === 'bim') {
                        this.appStore.setBimModuleLoaded();
                    }
                })
            );
        }
        return of(null);
    }
}
